import { pinia } from "../pinia";
import { useAppStore } from "../app.store";
/** Setup dışı köprü — kök analiz Pinia birincil (micro-7-3, micro-8-2) */
export function getAppStore() {
    return useAppStore(pinia);
}
